"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
exports.default = createIconComponent_1.default("ArrowDown", React.createElement("path", { fill: "currentColor", d: "M22.6,12.8c0.6-0.6,0.6-1.5,0-2.1c-0.6-0.6-1.5-0.6-2.1,0L12,19.2l-8.4-8.4c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1\n\tl9.5,9.5c0.6,0.6,1.5,0.6,2.1,0L22.6,12.8z M10.5,1.9v19.4h3V1.9H10.5z" }));
//# sourceMappingURL=ArrowDown.js.map